export default function getLastSTringChars(string, nb){
  return string.slice(1).slice(-nb);
}